export const getPlayerContainer = ({player}) => player;
export const getPlayer = ({player}) => player.item;
